import React from 'react';

const AccessDeniedIcon = () => {
  return (
    <svg
      width='390'
      height='276'
      viewBox='0 0 390 276'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_14766_55439)'>
        <path
          d='M90.3664 66.155C93.703 66.155 96.4079 63.4478 96.4079 60.0962C96.4079 56.766 93.703 54.0588 90.3664 54.0588C87.0298 54.0588 84.3228 56.766 84.3228 60.0962C84.3228 63.4478 87.0298 66.155 90.3664 66.155Z'
          fill='#F1F3F9'
        />
        <path
          d='M194.803 247.615C255.223 247.615 304.204 198.63 304.204 138C304.204 77.37 255.006 28.3846 194.803 28.3846C134.386 28.3846 85.4028 77.37 85.4028 138C85.4028 198.63 134.386 247.615 194.803 247.615Z'
          fill='#EAEEF9'
        />
        <g filter='url(#filter0_d_14766_55439)'>
          <path
            d='M311.73 64.6296V211.478C311.73 217.902 306.522 223.187 300.092 223.187H89.0103C82.5799 223.187 77.3076 217.966 77.3076 211.478V64.6296C77.3076 58.2057 82.5154 52.9845 89.0103 52.9845H300.092C306.522 52.9845 311.73 58.2057 311.73 64.6296Z'
            fill='url(#paint0_linear_14766_55439)'
          />
          <path
            d='M216.485 99.2843H291.682'
            stroke='#E8EDF8'
            stroke-width='6.92308'
            stroke-miterlimit='10'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M96.1709 99.2843H199.298'
            stroke='#E8EDF8'
            stroke-width='6.92308'
            stroke-miterlimit='10'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M96.1709 129.363H291.682'
            stroke='#E8EDF8'
            stroke-width='6.92308'
            stroke-miterlimit='10'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M175.665 159.442H291.682'
            stroke='#E8EDF8'
            stroke-width='6.92308'
            stroke-miterlimit='10'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M96.1709 159.442H158.477'
            stroke='#E8EDF8'
            stroke-width='6.92308'
            stroke-miterlimit='10'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M96.1709 189.521H203.595'
            stroke='#E8EDF8'
            stroke-width='6.92308'
            stroke-miterlimit='10'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </g>
        <path
          d='M312.212 64.6296V76.7898H77.7891V64.6296C77.7891 58.2057 82.9969 52.9845 89.4917 52.9845H300.573C307.004 52.9845 312.212 58.2057 312.212 64.6296Z'
          fill='#D5DDEA'
        />
        <path
          d='M90.4538 68.0454C92.2306 68.0454 93.6701 66.6059 93.6701 64.8227C93.6701 63.0395 92.2306 61.6 90.4538 61.6C88.6792 61.6 87.2397 63.0395 87.2397 64.8227C87.2397 66.6059 88.6792 68.0454 90.4538 68.0454Z'
          fill='#989FB0'
        />
        <path
          d='M100.099 68.0454C101.873 68.0454 103.313 66.6059 103.313 64.8227C103.313 63.0395 101.873 61.6 100.099 61.6C98.3242 61.6 96.8848 63.0395 96.8848 64.8227C96.8848 66.6059 98.3242 68.0454 100.099 68.0454Z'
          fill='#989FB0'
        />
        <path
          d='M109.679 68.0454C111.454 68.0454 112.893 66.6059 112.893 64.8227C112.893 63.0395 111.454 61.6 109.679 61.6C107.904 61.6 106.465 63.0395 106.465 64.8227C106.465 66.6059 107.904 68.0454 109.679 68.0454Z'
          fill='#989FB0'
        />
        <path
          d='M231.923 146.654C231.923 151.484 231.13 155.924 229.342 160.156C225.372 170.638 216.837 178.711 206.315 182.33C202.742 183.541 198.971 184.154 195 184.154C174.553 184.154 158.077 167.422 158.077 146.654C158.077 125.885 174.553 109.154 195 109.154C215.447 109.154 231.923 126.094 231.923 146.654Z'
          fill='url(#paint1_linear_14766_55439)'
        />
        <path
          d='M202.462 139.783V132.538C202.462 128.587 199.168 125.308 195.214 125.308C193.237 125.308 191.478 126.177 189.941 127.494C188.623 128.811 187.744 130.563 187.744 132.763V140.007C185.767 141.324 184.229 142.865 182.911 145.051C181.813 147.027 181.154 149.452 181.154 151.862C181.154 159.541 187.305 165.692 194.994 165.692C202.682 165.692 208.833 159.541 208.833 151.862C209.052 146.593 206.416 142.207 202.462 139.783ZM196.751 153.179V156.906C196.751 157.341 196.312 157.789 195.873 157.789H194.335C193.896 157.789 193.455 157.341 193.455 156.906V154.496V153.179C192.137 152.52 191.478 150.979 191.698 149.452C191.919 148.134 193.017 147.027 194.335 146.817C196.532 146.369 198.509 148.134 198.509 150.11C198.509 151.427 197.85 152.52 196.751 153.179ZM198.948 138.255C197.63 137.807 196.532 137.597 194.994 137.597C193.676 137.597 192.357 137.807 191.039 138.255V132.763C191.039 131.67 191.478 130.563 192.137 129.904C192.796 129.245 193.896 128.811 194.994 128.811C197.191 128.811 198.948 130.563 198.948 132.763V138.255Z'
          fill='white'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_14766_55439'
          x='30.0411'
          y='29.3512'
          width='328.955'
          height='264.735'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='23.6333' />
          <feGaussianBlur stdDeviation='23.6333' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_14766_55439'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_14766_55439'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_14766_55439'
          x1='194.443'
          y1='49.0528'
          x2='194.443'
          y2='225.013'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FDFEFF' />
          <stop offset='0.9964' stop-color='#ECF0F5' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_14766_55439'
          x1='158.043'
          y1='146.654'
          x2='231.937'
          y2='146.654'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#B0BACC' />
          <stop offset='1' stop-color='#969EAE' />
        </linearGradient>
        <clipPath id='clip0_14766_55439'>
          <rect
            width='390'
            height='274.615'
            fill='white'
            transform='translate(0 0.692383)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AccessDeniedIcon;
